module.exports = __webpack_public_path__ + "static/media/success(6) (Custom).38bfe4b4.png";